import axios from 'axios';

axios.interceptors.response.use(
        response => response,
        error => {
            if (error.response && error.response.status === 403) {
                window.location.href = "/infos?useCase=expiredSession";
                // "never-resolving" Promise pour arrêter la chaîne de promise, see https://github.com/axios/axios/issues/715
                return new Promise(() => {});
            }
            return Promise.reject(error);
        });

export default axios;
